import { apiServer } from '../settings'
import {getToken} from './token'

const getJackpotsByType = (game, type, done) => {
	if (!game) return done('missing game')
	if (!type) return done('missing type')

	const headers = new Headers({'Authorization': 'Bearer ' + getToken()})

	const options = { method: 'GET', headers, mode: 'cors', cache: 'default' }

	const url = `${apiServer}/get-jackpots-by-type?game=${game}&type=${type}`

	fetch(url, options)
		.then(function(response) {
			return response.json()
		})
		.then(function(response) {
			if (response.success === false) return done(response.err)
			if (response.success === true) return done(null, response.result)
			if (!response.success) return done('response without success true|false')
		})
}


export default getJackpotsByType
